const Card: FC = ({ children }) => (
  <div className="relative grid cursor-pointer rounded-moon-s-sm bg-gohan p-5 text-bulma rem:h-[444px] rem:w-[340px] md:rem:h-[540px] md:rem:w-[480px]">
    {children}
  </div>
);

export default Card;
